import { useState, useRef } from "react";
import EnrichmentModal from "../manchester/EnrichmentModal";
import useAddressAutocomplete from "@/hooks/useAddressAutocomplete";

export default function CityHero({ config }) {
  const [address, setAddress] = useState("");
  const [showModal, setShowModal] = useState(false);
  const addressInputRef = useRef(null);

  const handleGetStarted = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  useAddressAutocomplete(addressInputRef, (addr) => setAddress(addr), { deps: [] });

  return (
    <section
      id="ts-hero"
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: "clamp(110px, 14vw, 160px)",
        paddingBottom: "48px",
        paddingLeft: "clamp(16px, 5vw, 40px)",
        paddingRight: "clamp(16px, 5vw, 40px)",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div
        role="img"
        aria-label={config.heroAlt}
        style={{
          position: "absolute", inset: 0,
          backgroundImage: `url(${config.heroImage})`,
          backgroundSize: "cover", backgroundPosition: "center",
          filter: "blur(7px)", transform: "scale(1.1)", zIndex: 0,
        }}
      />
      <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1 }} />

      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2, width: "100%", textAlign: "center", boxSizing: "border-box", flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(255,255,255,0.9)", marginBottom: 20, marginTop: 0 }}>
          Airbnb management in {config.cityName}
        </p>

        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(34px, 5vw, 60px)", lineHeight: 1.08, letterSpacing: "-0.03em", color: "#fff", margin: "0 auto 22px", maxWidth: 880 }}>
          Airbnb management in {config.cityName}, fully handled.
        </h1>

        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "clamp(17px, 2vw, 21px)", fontWeight: 400, color: "rgba(255,255,255,0.9)", lineHeight: 1.6, maxWidth: 720, margin: "0 auto 36px" }}>
          {config.heroText}
        </p>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, width: "100%", maxWidth: 640 }}>
          <form
            onSubmit={handleGetStarted}
            className="hero-form-wrap"
            style={{ display: "flex", gap: 10, width: "100%", maxWidth: 520, flexWrap: "wrap", justifyContent: "center" }}
          >
            <input
              ref={addressInputRef}
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Enter your property address"
              autoComplete="off"
              style={{
                flex: "1 1 280px",
                border: "none",
                outline: "none",
                fontFamily: "'Inter', sans-serif",
                fontSize: 15,
                color: "#112215",
                background: "#fff",
                borderRadius: 8,
                padding: "15px 20px",
                minWidth: 0,
                boxSizing: "border-box",
              }}
            />
            <button
              type="submit"
              style={{
                background: "#CD533B",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "15px 24px",
                fontFamily: "'Inter', sans-serif",
                fontSize: 15,
                fontWeight: 600,
                cursor: "pointer",
                transition: "background 0.2s",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#B8462F")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#CD533B")}
            >
              Get my free valuation
            </button>
          </form>

          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.7)", margin: 0, lineHeight: 1.5, textAlign: "center", maxWidth: 480 }}>
            Free earning estimate, sent within 24 hours. No obligation, and no call unless you ask.
          </p>
        </div>
      </div>

      <div style={{ position: "relative", zIndex: 2, textAlign: "center", paddingTop: "clamp(32px, 4vw, 48px)", maxWidth: 1200, margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "clamp(12px, 1.4vw, 14px)", color: "rgba(255,255,255,0.85)", fontWeight: 500, margin: 0, lineHeight: 1.6 }}>
          5.0 on Google (90+ reviews) <span style={{ color: "rgba(255,255,255,0.4)" }}>&middot;</span>{" "}
          +1,000 5 star Airbnb reviews <span style={{ color: "rgba(255,255,255,0.4)" }}>&middot;</span>{" "}
          35,000+ stays managed since 2019
        </p>
      </div>

      {showModal && <EnrichmentModal mode="full" baseForm={{ address }} onClose={() => setShowModal(false)} onSubmitted={() => setShowModal(false)} />}

      <style>{`
        @media (max-width: 768px) {
          #ts-hero { min-height: 100dvh !important; }
          #ts-hero h1 { font-size: 38px !important; }
          .hero-form-wrap { flex-direction: column !important; }
          .hero-form-wrap input { flex: none !important; width: 100% !important; }
          .hero-form-wrap button { width: 100% !important; }
        }
        @media (max-width: 480px) {
          #ts-hero { padding-left: 16px !important; padding-right: 16px !important; }
        }
      `}</style>
    </section>
  );
}